import { render } from "./GridTabParteneri.vue?vue&type=template&id=7bde860f&scoped=true&ts=true"
import script from "./GridTabParteneri.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneri.vue?vue&type=script&lang=ts"

import "./GridTabParteneri.vue?vue&type=style&index=0&id=7bde860f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bde860f"]])

export default __exports__